import { Env } from "@version2/domain-package";

export const APP_FEATURES = {
  ADD_ONS: "addOns",
  INTEGRATIONS: "integrations",
  CLIENTS: "clients",
} as const;

export type AppFeatureKey = (typeof APP_FEATURES)[keyof typeof APP_FEATURES];

export const APP_FEATURE_LABELS: Record<AppFeatureKey, string> = {
  [APP_FEATURES.ADD_ONS]: "Add-ons",
  [APP_FEATURES.INTEGRATIONS]: "Integrations",
  [APP_FEATURES.CLIENTS]: "Clients",
};

export const APP_FEATURE_REMOTE_CONFIG_KEYS: Record<AppFeatureKey, string> = {
  [APP_FEATURES.ADD_ONS]: "feat_app_add_ons_enabled",
  [APP_FEATURES.INTEGRATIONS]: "feat_app_integrations_enabled",
  [APP_FEATURES.CLIENTS]: "feat_app_clients_enabled",
};

export const DEFAULT_APP_FEATURE_ACCESS: Record<AppFeatureKey, boolean> = {
  [APP_FEATURES.ADD_ONS]: true,
  [APP_FEATURES.INTEGRATIONS]: true,
  [APP_FEATURES.CLIENTS]: true,
};

export const getDefaultAppFeatureAccess = (
  env: Env
): Record<AppFeatureKey, boolean> => ({
  ...DEFAULT_APP_FEATURE_ACCESS,
  [APP_FEATURES.INTEGRATIONS]: env === Env.STAGE,
});

export const DASHBOARD_FEATURE_FLAGS = {
  ADD_ONS_SORTING: "addOnsSorting",
  THEME_MODE_SWITCHING: "themeModeSwitching",
} as const;

export type DashboardFeatureFlagKey =
  (typeof DASHBOARD_FEATURE_FLAGS)[keyof typeof DASHBOARD_FEATURE_FLAGS];

export const DASHBOARD_FEATURE_REMOTE_CONFIG_KEYS: Record<
  DashboardFeatureFlagKey,
  string
> = {
  [DASHBOARD_FEATURE_FLAGS.ADD_ONS_SORTING]: "feat_dashboard_add_ons_sorting_enabled",
  [DASHBOARD_FEATURE_FLAGS.THEME_MODE_SWITCHING]:
    "feat_dashboard_theme_mode_switching_enabled",
};

export const DEFAULT_DASHBOARD_FEATURE_FLAGS: Record<
  DashboardFeatureFlagKey,
  boolean
> = {
  [DASHBOARD_FEATURE_FLAGS.ADD_ONS_SORTING]: true,
  [DASHBOARD_FEATURE_FLAGS.THEME_MODE_SWITCHING]: true,
};
